export default __webpack_public_path__ + "static/media/editor.90561287.svg";